module.exports = __webpack_public_path__ + "img/hong-kong.363c4faa.svg";